import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import App from './app';
import { gtag } from './components/withGTag';
import { VERSION } from './constants/env';
const rootElement = document.getElementById('root');
if (rootElement !== null) {
    ReactDOM.render(_jsx(App, {}), rootElement);
}
else {
    throw new Error('No #root element');
}
const navigatorDetails = (stack) => {
    const { platform, userAgent } = navigator;
    const output = ['navigator.platform=' + platform, 'navigator.userAgent=' + userAgent, 'stack=' + stack];
    return ' [' + output.join(', ') + ']';
};
window.addEventListener('error', (event) => {
    const { error, message } = event;
    const navigatorInfo = error ? navigatorDetails(error.stack) : '';
    gtag('event', 'exception', {
        description: 'App@v' + VERSION + ' on ' + location.href + ': ' + message + navigatorInfo,
        // 'fatal': false,
    });
});
window.addEventListener('unhandledrejection', (event) => {
    // @ts-expect-error TS2339: Property 'error' does not exist on type 'PromiseRejectionEvent'.
    const { error, reason } = event;
    const navigatorInfo = error ? navigatorDetails(error.stack) : '';
    const description = ['App@v' + VERSION + ' on ' + location.href,
        ': Unhandled rejection (reason: ' + (typeof reason === 'string' || !reason || !('stack' in reason) ? String(reason) : (reason.stack || String(reason))) + '). ',
        navigatorInfo,
    ];
    gtag('event', 'exception', {
        description: description.join(''),
        // 'fatal': false,
    });
});
